import { render, staticRenderFns } from "./ModalPrivateEventSuccess.vue?vue&type=template&id=63b87e88&scoped=true&"
import script from "./ModalPrivateEventSuccess.vue?vue&type=script&lang=js&"
export * from "./ModalPrivateEventSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrivateEventSuccess.vue?vue&type=style&index=0&id=63b87e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b87e88",
  null
  
)

export default component.exports